const DMPAMoreInfo = ({ extended }) => {
  return (
    <div className="dmpa_more_info">
      {extended && (
        <p>
          PRE-SCREEN & OPT-OUT NOTICE: This “prescreened” offer of credit is
          based on information in your credit report indicating that you meet
          certain criteria. This offer is not guaranteed if you do not meet our
          criteria, including providing accept-able property as collateral. If
          you do not want to receive prescreened offers of credit from this and
          other companies, call TransUnion at{' '}
          <a href="tel:1-888-567-8688">1-888-5OPTOUT (1-888-567-8688)</a>, visit
          the website at{' '}
          <a
            href="http://www.optoutprescreen.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.optoutprescreen.com
          </a>{' '}
          or write TransUnion Opt-Out Request, P.O. Box 505, Woodlyn, PA
          19094-0505.
        </p>
      )}

      {!extended && (
        <p>
          You can choose to stop receiving "prescreened" offers from this and
          other companies by calling toll-free{' '}
          <a href="tel:1-888-567-8688">1-888-567-8688</a>. See below for the
          information about prescreened offers.
        </p>
      )}
    </div>
  )
}

export default DMPAMoreInfo
